// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai_new_design[data-v-10720a9a] {
  max-width: 600px;
}
.min-120[data-v-10720a9a] {
  min-height: 100px;
}
.min_100[data-v-10720a9a] {
  display: inline-block;
  min-width: 150px;
  font-size: 13px;
}
.tvm_payment_progress[data-v-10720a9a] {
  max-width: 600px;
}
.tvm_payment_progress span[data-v-10720a9a] {
  font-size: 13px;
}
.tvm_payment_progress .progress_bar[data-v-10720a9a] {
  height: 45px;
  object-fit: contain;
}
.tvm_payment_progress .left_value[data-v-10720a9a] {
  left: -7px;
  top: 35px;
}
.tvm_payment_progress .middle_value[data-v-10720a9a] {
  right: 80px;
  top: 42px;
}
.tvm_payment_progress .right_value[data-v-10720a9a] {
  right: -7px;
  top: 35px;
}
@media screen and (min-width: 1900px) {
.tvm_payment_progress .middle_value[data-v-10720a9a] {
    right: 100px;
    top: 46px;
}
}
.animate_bottom[data-v-10720a9a] {
  animation: animateBottom-10720a9a 2s;
  transition: 0.5s;
}
@keyframes animateBottom-10720a9a {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.custom_legend[data-v-10720a9a] {
    font-size: 13px;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiBbTradeValue.vue","webpack://./AiBbTradeValue.vue"],"names":[],"mappings":"AAEA;EACE,gBAAA;ACDF;ADOA;EACE,iBAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;ACNF;ADUA;EAjBE,gBAAA;ACUF;ADOA;EAII,eAAA;ACRJ;ADIA;EAQI,YAAA;EACA,mBAAA;ACTJ;ADAA;EAaI,UAAA;EACA,SAAA;ACVJ;ADJA;EAkBI,WAAA;EACA,SAAA;ACXJ;ADRA;EAuBI,WAAA;EACA,SAAA;ACZJ;ADeE;AAAA;IAEI,YAAA;IACA,SAAA;ACbJ;AACF;ADiBA;EACE,oCAAA;EACA,gBAAA;ACfF;ADkBA;AACE;IACE,2BAAA;AChBF;ADmBA;IACE,wBAAA;ACjBF;AACF;ADoBA;AACE;IACE,eAAA;AClBF;AACF","sourcesContent":["\n// reuseable css\n.ai_new_design {\n  max-width: 600px;\n}\n\n\n\n\n.min-120 {\n  min-height: 100px;\n}\n\n.min_100 {\n  display: inline-block;\n  min-width: 150px;\n  font-size: 13px;\n}\n\n// end reuseable css\n.tvm_payment_progress {\n  .ai_new_design();\n\n  span {\n    font-size: 13px;\n  }\n\n  .progress_bar {\n    height: 45px;\n    object-fit: contain;\n  }\n\n  .left_value {\n    left: -7px;\n    top: 35px;\n  }\n\n  .middle_value {\n    right: 80px;\n    top: 42px;\n  }\n\n  .right_value {\n    right: -7px;\n    top: 35px;\n  }\n\n  @media screen and (min-width: 1900px) {\n    .middle_value {\n      right: 100px;\n      top: 46px;\n    }\n  }\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n",".ai_new_design {\n  max-width: 600px;\n}\n.min-120 {\n  min-height: 100px;\n}\n.min_100 {\n  display: inline-block;\n  min-width: 150px;\n  font-size: 13px;\n}\n.tvm_payment_progress {\n  max-width: 600px;\n}\n.tvm_payment_progress span {\n  font-size: 13px;\n}\n.tvm_payment_progress .progress_bar {\n  height: 45px;\n  object-fit: contain;\n}\n.tvm_payment_progress .left_value {\n  left: -7px;\n  top: 35px;\n}\n.tvm_payment_progress .middle_value {\n  right: 80px;\n  top: 42px;\n}\n.tvm_payment_progress .right_value {\n  right: -7px;\n  top: 35px;\n}\n@media screen and (min-width: 1900px) {\n  .tvm_payment_progress .middle_value {\n    right: 100px;\n    top: 46px;\n  }\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
